/**
 * Created by hp on 2017/4/26.
 */
// process.env.DEV_API_URL
// 全站的券包bag id
const couponBagId = '16'
const PRESET_MAIN_URL = window.Session &&  window.Session.preset_config &&  window.Session.preset_config.mainUrl

const protocol = window.location.protocol || 'http'

const PRESET_BASE_URL =  window.Session &&  window.Session.preset_config &&  window.Session.preset_config.baseUrl

let config = {
    WXAPPID: 'wx14b5c52fc6734a9c',
    WXWEBAPPID: 'wx7e1cda3610d49884',
    WBWEBAPPID: '2828365896',
    ALIPAYAPPID: '2016081500252312',
    BASE_URL: PRESET_BASE_URL || 'https://m.lizhiweike.com',
    ADMIN_BASE_URL: 'https://admin.lizhiweike.com',
    MAIN_URL: 'http://localhost:3000',
    WARNING_URL: 'http://localhost:3001',
    PGY_MALL_URL: `${protocol}//dev.pgy.lizhiweike.com`,
    PGY_API_URL: 'https://api-pgy.lizhiweike.com',
    WK_ADMIN_API: 'https://admin.lizhiweike.com',
    MSG_API_URL: 'https://mapi.lycheer.cn',
    REDIRECT_WARN: false,
    AUTH_URL: 'https://open.lizhiweike.com',
    CLIENT_ID: 'weike_fe',
    DEBUG: true,
    COUPON_BAG_ID: couponBagId,
    gateway_root_url: 'https://gateway.test.weike.fm'
}


export const prodConfig = {
    WXAPPID: 'wx3502aeb0c3639966',
    WXWEBAPPID: 'wx7e1cda3610d49884',
    WBWEBAPPID: '2828365896',
    ALIPAYAPPID: '2017081508206734',
    BASE_URL: PRESET_BASE_URL || 'https://apiv1.lizhiweike.com',
    ADMIN_BASE_URL: 'https://admin.lizhiweike.com',
    MAIN_URL: PRESET_MAIN_URL || 'https://m.lizhiweike.com',
    WARNING_URL: `${protocol}//weike.eva2.cn`,
    PGY_MALL_URL: 'https://pgy.lizhiweike.com',
    PGY_API_URL: 'https://api-pgy.lizhiweike.com',
    WK_ADMIN_API: 'https://admin.lizhiweike.com',
    MSG_API_URL: 'https://mapi.lycheer.cn',
    REDIRECT_WARN: false,
    AUTH_URL: 'https://open.lizhiweike.com',
    CLIENT_ID: 'weike_fe',
    DEBUG: false,
    COUPON_BAG_ID: couponBagId,
    BASE_URL_ELSE: 'https://api-gw.lizhiweike.com',
    gateway_root_url: 'https://gateway-weike.lizhiweike.com',
}

let main_url_config = {
    WK_PAGE_BASEURL: prodConfig.MAIN_URL
}


if (process.env.NODE_ENV === 'production') {
    config = prodConfig
}

if (process.env.NODE_ENV !== 'production') {
    main_url_config = {
        WK_PAGE_BASEURL: `${protocol}//dbg.lizhiweike.com`
    }
}

if (window.location.host === 'dbg.weike.fm' || '139.199.89.56' === location.hostname ||'dbg.lizhiweike.com' === location.hostname || 'localhost' === location.hostname) {
    config = {
        WXAPPID: 'wxbafd424a88af8eb8',
        WXWEBAPPID: 'wx7e1cda3610d49884',
        WBWEBAPPID: '2828365896',
        ALIPAYAPPID: '2016081500252312',
        BASE_URL: localStorage.getItem('_api') || `${protocol}//dbg.lizhiweike.com` /* `${protocol}//dbg.weike.fm` */,   //  http://dbg.weike.fm:80
        ADMIN_BASE_URL: 'https://dev.admin.lizhiweike.com',
        MAIN_URL: `${protocol}//dbg.lizhiweike.com`,
        WARNING_URL: `${protocol}//weike.eva2.cn`,
        PGY_MALL_URL: `${protocol}//dev.pgy.lizhiweike.com`,
        PGY_API_URL: `${protocol}//api.dev.pgy.lizhiweike.com`,
        WK_ADMIN_API: `${protocol}//dev.admin.lizhiweike.com`,
        MSG_API_URL: 'https://mapi.lycheer.cn',
        REDIRECT_WARN: false,
        AUTH_URL: 'https://dev.open.lizhiweike.com',
        CLIENT_ID: 'weike_fe',
        DEBUG: true,
        COUPON_BAG_ID: couponBagId,
        BASE_URL_ELSE: `${protocol}//api.dev10.weike.fm`,
        gateway_root_url: 'https://gateway.test.weike.fm'
    }
}

if (window.localStorage.getItem('env') === 'mock' && process.env.NODE_ENV !== 'production') {
    config = {
        WXAPPID: 'wx14b5c52fc6734a9c',
        WXWEBAPPID: 'wx7e1cda3610d49884',
        WBWEBAPPID: '2828365896',
        ALIPAYAPPID: '2016081500252312',
        BASE_URL: 'https://easy-mock.com/mock/59f3028b787bd45156a0b944',
        ADMIN_BASE_URL: 'https://admin.lizhiweike.com',
        MAIN_URL: `${protocol}//dbg.weike.fm:8020`,
        WARNING_URL: `${protocol}//weike.eva2.cn`,
        AUTH_URL: 'https://open.lizhiweike.com',
        MSG_API_URL: 'https://mapi.lycheer.cn',
        CLIENT_ID: 'weike_fe',
        REDIRECT_WARN: false,
        DEBUG: false
    }
}

export default config

export const MAIN_URL_CONFIG = main_url_config

export const isProdMainHost = prodConfig.MAIN_URL && prodConfig.MAIN_URL.indexOf(window.location.hostname) !== -1

export const getMainHost = () => {
    if (PRESET_MAIN_URL) {
        let newMainUrl  = PRESET_MAIN_URL
        newMainUrl = newMainUrl.replace('https://', '')
        newMainUrl = newMainUrl.replace('http://', '')
        return newMainUrl
    }

    return 'm.lizhiweike.com'
}



// WEBPACK FOOTER //
// ./src/config.js